import {
  createTheme,
  createThemedStyled,
  createThemedUseStyletron,
  createThemedWithStyle,
} from 'baseui';
import type { Theme } from 'baseui';

import colors from './styles.colors';
import lighting from './styles.lighting';
import mediaQuery from './styles.mediaquery';
import typography, { fontFamily } from './styles.typography';

export const primitives = {
  primaryFontFamily: fontFamily,
};

const overrides = {
  colors,
  typography,
  mediaQuery,
  lighting,
};

const theme = createTheme(primitives, overrides);

interface CustomThemeInterface {
  colors: typeof colors;
  typography: typeof typography;
  mediaQuery: typeof mediaQuery;
  lighting: typeof lighting;
}

const customThemeValue: CustomThemeInterface = {
  colors,
  typography,
  mediaQuery,
  lighting,
};

export type CustomTheme = Theme & CustomThemeInterface;

const CustomThemes: CustomTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    ...customThemeValue.colors,
  },
  typography: {
    ...theme.typography,
    ...customThemeValue.typography,
  },
  mediaQuery: {
    ...theme.mediaQuery,
    ...customThemeValue.mediaQuery,
  },
  lighting: {
    ...theme.lighting,
    ...customThemeValue.lighting,
  },
};

export const themedStyled = createThemedStyled<CustomTheme>();
export const themedWithStyle = createThemedWithStyle<CustomTheme>();
export const themedUseStyletron = createThemedUseStyletron<CustomTheme>();
export const PROJECT_THEME = CustomThemes;
